import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [csrfToken, setCsrfToken] = useState("");

    // 🔐 Fetch CSRF token from meta tag
    useEffect(() => {
        const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
        setCsrfToken(token || "");
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const formData = new FormData();
        formData.append("user[email]", email);
        formData.append("user[password]", password);

        try {
            const res = await fetch("/users/sign_in", {
                method: "POST",
                headers: {
                    "X-CSRF-Token": csrfToken, // still required
                },
                body: formData,
                credentials: "include",
            });

            if (res.ok) {
                navigate("/admin");
            } else {
                const text = await res.text(); // Devise may not return JSON here
                setError("Invalid email or password.");
            }
        } catch (err) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>
            <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <Input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />

                {error && <p className="text-sm text-red-600">{error}</p>}

                <Button type="submit" className="w-full bg-[#5D1F42] hover:bg-[#4a1938]" disabled={loading}>
                    {loading ? "Signing in..." : "Sign In"}
                </Button>
            </form>
        </div>
    );
}
